{
  "account.emptyFavoriteBrands.subTitle": "Favoritmarkera dina märken och få notiser om nyheter och kampanjer",
  "account.emptyFavoriteBrands.title": "Håll koll på dina favoritmärken",
  "account.emptyFavorites.subTitle": "Favoritmarkera dina produkter och få notiser om nyheter och kampanjer",
  "account.emptyFavorites.title": "Håll koll på dina favoritprodukter",
  "account.emptyOrder.cta": "Börja shoppa",
  "account.emptyOrder.subTitle": "Så fort du har handlat något så kommer din senaste order att ligga här.",
  "account.emptyOrder.subTitle.selection": "Välj ett annat år eller urval för att se ordrar.",
  "account.emptyOrder.title": "Du har inte handlat något ännu",
  "account.emptyOrder.title.selection": "Du inga ordrar för det valda året/urvalet",
  "account.emptyOrder.title.emptyQuery": "Välj företag i filtret",
  "account.favoriteBrandsCta": "Alla varumärken",
  "account.favoriteBrandsHeading": "Favoritmärken",
  "account.favoritesCta": "Alla produkter",
  "account.favoritesHeading": "Favoriter",
  "account.latestOrderHeading": "Senaste ordern",
  "account.seeAll": "Se alla",
  "addedToCart.fail": "Det gick tyvärr inte att lägga till i korgen just nu",
  "addedToCart.headline": "Tillagd",
  "addedToCart.numProductsAdded": "{num} produkter lades till i varukorgen",
  "apiError.unauthorized": "Du har inte rätt att utföra åtgärden. Kontakta support",
  "apiError.unknown": "Ett okänt fel har inträffat. Kontakta support",
  "articles.keyword.articles": "Artiklar",
  "articles.keyword.articles.read": "Läs artikeln",
  "articles.keyword.guides": "Guider",
  "articles.keyword.guides.read": "Läs guiden",
  "articles.keyword.interviews": "Intervjuer",
  "articles.keyword.interviews.read": "Läs intervjun",
  "articles.keyword.news": "Nyheter",
  "articles.keyword.news.read": "Läs nyheten",
  "articles.keyword.funny": "Roliga",
  "articles.latestBtn": "Senaste",
  "articles.loadmore": "Ladda fler",
  "articles.read": "Läs",
  "articles.relatedHeadline": "Relaterade artiklar",
  "articles.total.none": "Inga artiklar",
  "articles.total.plur": "{num} artikar",
  "articles.total.sing": "1 artikel",
  "articles.viewed": "Du har tittat på {current} av {total} artiklar",
  "articles.keyword.blondesolutions": "Blonde Solutions",
  "articles.keyword.epres": "Epres",
  "articles.keyword.hottools": "Hot Tools",
  "articles.keyword.k18": "K18",
  "articles.keyword.kevinmurphy": "Kevin Murphy",
  "articles.keyword.livingproof": "Living Proof",
  "articles.keyword.elevenaustralia": "Eleven Australia",
  "articles.keyword.lenoites": "Lenoites",
  "articles.keyword.sessionsälen": "Session Sälen",
  "articles.keyword.nyheter": "Nyheter",
  "body.inputWithDropdown.multipleItemsSelected": "{itemCount} valda",
  "brandlist.allCategories": "Alla märken a-ö",
  "brandlist.favorites.headline": "Dina favoriter",
  "checkout.backToShopping": "Fortsätt handla",
  "checkout.invoice.notAvailableForCompany": "{companyName} får inte handla på faktura",
  "checkout.cartSettings.closeCta": "Dölj orderinställningar",
  "checkout.cartSettings.openCta": "Visa orderinställningar",
  "checkout.customAddressRadio": "Skicka till annan adress",
  "checkout.customerSuccessProducts.closeCta": "Dölj ytterligare produkter",
  "checkout.customerSuccessProducts.openCta": "Visa ytterligare produkter",
  "checkout.customerSuccessProducts.placeholder": "Skriv meddelande...",
  "checkout.customerSuccessProducts.noProducts": "Du har lagt till alla tillgängliga ytterligare produkter.",
  "checkout.empty": "Din varukorg är tom",
  "checkout.expeditedDelivery.label": "Hantera ordern skyndsamt",
  "checkout.extendedPaymentTime.label": "Förläng betalningsdatumet",
  "checkout.invoice.billingInputHeadline": "Leveransadress",
  "checkout.invoice.completePurchase": "Slutför köp",
  "checkout.invoice.deliveryMethodsHeadline": "Leveranssätt",
  "checkout.invoice.genericError": "Något gick fel, var god försökt igen eller kontakta kundtjänst",
  "checkout.invoice.paymentMethodsHeadline": "Betalningsmetod",
  "checkout.invoice.summaryHeadline": "Ordersumma",
  "checkout.leadtimeSuffix": "arbetsdagar",
  "checkout.newsletterHeadline": "Du finns inte med på vår nyhetsbrevslista",
  "checkout.newsletterLabel": "Skicka nyhetsbrev med nyheter och erbjudanden",
  "checkout.checkoutType.headline": "Vad vill du göra?",
  "checkout.checkoutType.purchase": "Slutföra köp åt kund",
  "checkout.checkoutType.orderProposal": "Skapa orderförslag åt kund",
  "checkout.orderProposal.headline.create": "Skapa orderförslag åt kund",
  "checkout.orderProposal.addComment": "Lägg till en kommentar",
  "checkout.orderProposal.resend": "Skicka om orderförslag",
  "checkout.orderProposal.saveDraft": "Spara utkast",
  "checkout.orderProposal.updateDraft": "Uppdatera utkast",
  "checkout.orderProposal.update": "Uppdatera orderförslag",
  "checkout.orderProposal.updated": "Orderförslaget uppdaterades",
  "checkout.orderProposal.send": "Skicka orderförslag",
  "checkout.orderProposal.sentAt": "Orderförslag skickat {time}",
  "checkout.orderProposal.editDiscount": "Lägg till rabatterad produkt",
  "checkout.orderProposal.noDiscounts": "Det finns inga specifika säljarrabatter för denna produkt.",
  "checkout.orderProposal.saveDiscount": "Spara och stäng",
  "checkout.orderProposal.saved": "Utkast sparat",
  "checkout.orderProposal.savedAt": "Utkast sparat {time}",
  "checkout.orderProposal.sent": "Orderförslag skickat till {name}",
  "checkout.orderProposal.validUntil": "Välj giltighetstid",
  "checkout.orderProposal.week": "vecka",
  "checkout.orderProposal.weeks": "veckor",
  "checkout.orderProposal.cancel": "Avbryt",
  "checkout.orderProposal.addMore": "Lägg till fler produkter",
  "checkout.pageTitle": "Kassan",
  "checkout.pageTitle.fail": "Fel i betalning",
  "checkout.pageTitle.success": "Tack för ditt köp",
  "checkout.salonRadio": "Skicka till salong",
  "checkout.salonSelectLabel": "Välj salong",
  "checkout.saveShippingAction": "Spara leveransadress",
  "checkout.shippingSavedMessage": "Adress sparad",
  "checkout.signup.alreadyMember": "Är du redan medlem?",
  "checkout.support": "Behöver du hjälp?",
  "checkout.verifyDetails": "Verifiera uppgifterna",
  "checkout.verifyDetails.payer": "Betalare",
  "checkout.verifyDetails.notCorrectHeadline": "Stämmer inte uppifterna?",
  "checkout.verifyDetails.notCorrectText": "Prova att ladda om sidan. Om det inte hjälper klicka på \"Rensa varukorg\" och gör om din beställning.",
  "checkout.verifyDetails.clearBasket": "Rensa varukorg",
  "country.dk": "Danmark",
  "country.fi": "Finland",
  "country.no": "Norge",
  "country.se": "Sverige",
  "country.selectCountry": "Välj land",
  "country.uk": "UK",
  "customer.company": "Företag",
  "customer.modalHeadline": "Hej där! Privat eller företag?",
  "customer.privatePerson": "Privatperson",
  "dropdown.generic": "Välj",
  "error.generic": "Något gick fel, var god försök igen eller kontakta kundtjänst",
  "error500.button": "Gå till framsidan",
  "error500.headline": "Det här är pinsamt…",
  "error500.subheadline": "Något har gått fel hos oss. Vi är medvetna om detta och arbetar på att åtgärda det.",
  "error500.try1": "Uppdatera sidan (ibland hjälper det)",
  "error500.try2": "Försök igen om 30 minuter",
  "error500.try3": "Kontakta <a href=\"mailto:support@session.nu\">support@session.nu</a>",
  "error500.tryHeadline": "Funkar inte sidan? Prova att:",
  "favorite.outOfStock": "Slut i lager",
  "favorite.button.add": "Lägg till som favorit",
  "favorite.button.add.brand": "Lägg till som favorit",
  "favorite.button.remove": "Ta bort favorit",
  "favorite.button.remove.brand": "Tillagd i favoriter",
  "favorites.btnCta": "Lägg alla i varukorgen",
  "favorites.btnSecondaryCta": "Töm listan",
  "favorites.discountLabel": "Rabatt",
  "favorites.pointsLabel": "Poäng på köpet",
  "favorites.priceTitle": "Listans totalpris",
  "favorites.totalPriceLabel": "Delsumma inkl. moms",
  "favorites.totalPriceExTaxLabel": "Delsumma exkl. moms",
  "favorites.totalVat": "Moms",
  "filter.button": "Filtrera",
  "filter.button.clear": "Rensa",
  "filter.button.show.plur": "Visa {num} produkter",
  "filter.countResults.plur": "{num} produkter",
  "filter.countResults.sing": "1 produkt",
  "filter.jumpToProducts": "Se alla produkter",
  "filter.loadmore": "Visa fler",
  "filter.modalTitle": "Filtrera",
  "filter.name.brandFilters": "Varumärke",
  "filter.search.category": "Sök {category}",
  "filter.sort.alpha_asc": "Bokstavsordning",
  "filter.sort.alpha_desc": "Z -> A",
  "filter.sort.default": "Populära",
  "filter.sort.prefix": "Sortera:",
  "filter.sort.price_asc": "Pris: Lägst först",
  "filter.sort.price_desc": "Pris: Högst först",
  "filter.sort.price_asc.points": "Poäng: Lägst först",
  "filter.sort.price_desc.points": "Poäng: Högst först",
  "filter.sort.title": "Sortering",
  "filter.sort.date_desc": "Senast inkommet",
  "filter.viewed": "Du har tittat på {current} av {total} produkter",
  "footer.newsletter.content": "Prenumerera på vårt nyhetsbrev och ta del av rykande färska nyheter, speciella erbjudanden, sköna tips och intressant läsning.",
  "footer.newsletter.error": "Det gick inte att registrera dig för nyhetsbrevet för tillfället. Vänligen försök igen senare!",
  "footer.newsletter.headline": "Nyhetsbrev",
  "footer.newsletter.placeholder": "Ange din e-postadress",
  "footer.newsletter.welcome": "Välkommen, {email} är nu registrerad till vårt nyhetsbrev!",
  "form.back": "Tillbaka",
  "form.invalid.email": "Ogiltig e-post",
  "form.invalid.max_chars": "Max {max} tecken",
  "form.invalid.min_chars": "Minst {min} tecken",
  "form.invalid.phone": "Ogiltigt telefonnummer",
  "form.invalid.postal_code": "Ogiltigt postnummer",
  "form.invalid.required": "Måste fyllas i",
  "form.placeholder.city": "Ort",
  "form.placeholder.companyName": "Företagsnamn",
  "form.placeholder.country": "Land",
  "form.placeholder.email": "E-postadress",
  "form.placeholder.firstName": "Förnamn",
  "form.placeholder.lastName": "Efternamn",
  "form.placeholder.message": "Meddelande..",
  "form.placeholder.orgNo": "Organisationsnummer",
  "form.placeholder.phone": "Telefonnummer",
  "form.placeholder.shippingPhone": "Telefonnummer för fraktavisering",
  "form.placeholder.street": "Adress",
  "form.placeholder.zip": "Postnummer",
  "header.cart": "Varukorg",
  "header.favorites": "Favoriter",
  "header.impersonate": "Se som kund",
  "header.menu": "Meny",
  "header.menu.open": "Öppna meny",
  "header.myPage": "Mina sidor",
  "header.sellerTools": "Säljverktyg",
  "header.customerSuccessImpersonate": "Logga in som kund",
  "impersonateModal.title": "Se som kund",
  "impersonateModal.search": "Sök kund",
  "impersonateModal.customerSuccess.title": "Logga in som kund",
  "impersonateModal.customerSuccess.placeholder": "Sök på salongens namn eller kundnr...",
  "impersonateModal.customerSuccess.cta": "Logga in som",
  "impersonateModal.customerSuccess.stopImpersonating": "Sluta se som kund",
  "impersonateModal.customerSuccess.success": "Kund hittad, loggar in som {{companyName}}",
  "impersonateModal.customerSuccess.error": "Kunden hittades inte, försök igen",
  "impersonateModal.customerSuccess.loggedInAs": "Inloggad som",
  "impersonate.error.missingCode": "Företaget saknar kod.",
  "impersonate.stop": "Sluta se som kund",
  "invite.accept.button": "Färdigställ konto",
  "invite.accept.error": "Länken du har följt är felaktig. Kontrollera länken eller kontakta support",
  "invite.accept.finished": "Ditt konto är nu klart och du kommer loggas in automatiskt inom kort.",
  "invite.accept.headline": "Acceptera inbjudan",
  "invite.accept.text": "Fyll i dina uppgifter för att aktivera ditt konto",
  "invoice.filter.all": "Visa alla",
  "invoice.filter.paid": "Betald",
  "invoice.filter.pending": "Inväntar betalning",
  "invoice.filter.refunded": "Återbetald",
  "invoice.status.paid": "Betald",
  "invoice.status.pastDue": "Förfallen",
  "invoice.status.pending": "Inväntar betalning",
  "invoice.status.refunded": "Återbetald",
  "invoice.status.paidLate": "Betald försent",
  "invoices.table.invoiceDate": "Fakturadatum",
  "invoices.table.invoiceNumber": "Fakturanummer",
  "invoices.table.status": "Status",
  "invoices.table.total": "Totalsumma",
  "invoices.title": "Fakturor",
  "loading": "Laddar",
  "minicart.discount.abort": "Avbryt",
  "minicart.discount.activate": "Tillämpa",
  "minicart.discount.button": "Lägg till rabattkod",
  "minicart.discount.invalidCode": "Ogiltig kod",
  "minicart.discount.placeholder": "Ange rabattkod",
  "minicart.empty": "Din varukorg är tom",
  "minicart.freeShippingReached": "Fri frakt uppnådd. Tips till dig:",
  "minicart.headline": "Varukorg",
  "minicart.leftToFreeShipping": "Handla för {amount} kr till så bjuder vi på frakten",
  "minicart.summary.discount": "Du sparar",
  "minicart.summary.exVat": "Totalsumma exkl. moms",
  "minicart.summary.freight": "Frakt",
  "minicart.summary.incVat": "Totalsumma inkl. moms",
  "minicart.summary.originalPrice": "Ord. pris {price}",
  "minicart.summary.points": "Poäng på köpet",
  "minicart.summary.pointsInfo": "Efter genomfört köp (om du handlat för minst {amount}) kan du handla backbars och testers för poängen",
  "minicart.summary.pointsSuffix": "poäng",
  "minicart.summary.sum": "Delsumma",
  "minicart.summary.vat": "Moms",
  "minicart.toCheckout": "Gå till kassan",
  "minicart.progressbar.left": "{sum} kvar till fri frakt",
  "minicart.barcode.scan": "Skanna produkt",
  "minicart.progressbar.full": "Du har uppnått fri frakt!",
  "modelModal.cta": "Byt modell",
  "modelModal.title": "Byt modell",
  "mypage.acceptOrderProposal.success": "Orderförslaget lades i varukorgen",
  "mypage.communications.newsletter": "Ja tack, skicka gärna nyhetsbrev till mig!",
  "mypage.communications.subheadline": "Kommunikationsinställningar",
  "mypage.communications.text": "I nyhetsbrevet hittar du schyssta erbjudanden och nyheter. Du kan avsluta när du önskar. Självklart har vi på Session Map en tydlig integritetspolicy.",
  "mypage.communications.updated": "Kommunikationsinställningar uppdaterade",
  "mypage.customer.searchPlaceholder": "Sök på salongens namn eller kundnr…",
  "mypage.customer.selectedPlaceholder": "Valda salonger",
  "mypage.customer.seeAllOrders": "Se alla ordrar",
  "mypage.customer.seeAsCustomer": "Se som kund",
  "mypage.customer.shopAsCustomer": "Handla som kund",
  "mypage.customer.stopShopAsCustomer": "Sluta handla som kund",
  "mypage.customer.title": "Mina kunder",
  "mypage.nav.cs": "Kundtjänst",
  "mypage.customers": "Mina kunder",
  "mypage.delivery.add": "Lägg till leveransadress",
  "mypage.delivery.change": "Ändra leveransadress",
  "mypage.delivery.sameAsInvoice": "Samma som fakturaadress",
  "mypage.deliveryAddress.delete": "Radere leveransadress",
  "mypage.deliveryAddresses": "Leveransadress",
  "mypage.edit": "Redigera",
  "mypage.edit.add": "Lägg till",
  "mypage.edit.email": "E-post",
  "mypage.edit.name": "Namn",
  "mypage.edit.password": "Lösenord",
  "mypage.edit.phone": "Telefonnummer",
  "mypage.edit.save": "Spara ändringar",
  "mypage.emptyOrderProposals.salesSubTitle": "När du har skapat ett orderförlag så kommer det dyka upp här",
  "mypage.emptyOrderProposals.salesTitle": "Du har inga orderförslag",
  "mypage.emptyOrderProposals.subTitle": "Så fort din säljare har skapat ett orderförlag så kommer det dyka upp här",
  "mypage.emptyOrderProposals.title": "Du har inga orderförslag",
  "mypage.favorites": "Favoriter",
  "mypage.headline": "Mina sidor",
  "mypage.invoiceAddress": "Fakturaadress",
  "mypage.invoices": "Fakturor",
  "mypage.logout": "Logga ut",
  "mypage.notLoggedin": "Du är inte inloggad",
  "mypage.notifications.invoice.btn": "Se faktura",
  "mypage.notifications.invoice.text": "Du har en faktura som har förfallit och måste betalas omgående",
  "mypage.notifications.invoice.title": "Din faktura har förfallit",
  "mypage.notifications.orderProposal.btn": "Se orderförslag",
  "mypage.notifications.orderProposal.text": "Du har ett nytt orderförslag",
  "mypage.notifications.orderProposal.title": "Nytt orderförslag",
  "mypage.orderHistory": "Orderhistorik",
  "mypage.orderHistory.mobile": "Ordrar",
  "mypage.orderHistory.salesRepNotImpersonating": "Du behöver logga in som en kund för att lägga något i varukorgen",
  "mypage.orderHistory.salesRepNotImpersonatingCorrectCompany": "Du behöver logga in som kunden för den här ordern för att lägga den i varukorgen igen.",
  "mypage.orderProposal": "Orderförslag",
  "mypage.orderProposalHelp": "Nedan kan du se orderförslag som skickats till dig från säljare. Du kan välja att lägga hela orderförslaget i varukorgen och sedan redigera det om du vill.",
  "mypage.orderProposals": "Orderförslag",
  "mypage.orderProposal.declined": "Avvisat",
  "mypage.orderProposal.declinedFilter": "Avvisade",
  "mypage.orderProposal.expired": "Utgått",
  "mypage.orderProposal.expiredFilter": "Utgångna",
  "mypage.orderProposal.order": "Godkänd",
  "mypage.orderProposal.acceptedFilter": "Godkända",
  "mypage.orderProposal.acceptedPartlyFilter": "Delvis godkända",
  "mypage.orderProposal.partlyOrdered": "Delvis godkänd",
  "mypage.orderProposal.draft": "Utkast",
  "mypage.orderProposal.greetings": "Mvh",
  "mypage.orderProposal.mobile": "Förslag",
  "mypage.orderProposal.salesRepOffer": "Erbjudande från din säljare, gäller vid köp av minst {num} st",
  "mypage.orderProposal.sent": "Skickad",
  "mypage.orderProposal.sentFilter": "Skickade",
  "mypage.orderProposal.all": "Alla",
  "mypage.orderProposal.options": "Mer",
  "mypage.orderProposal.view": "Visa",
  "mypage.orderProposal.edit": "Ändra",
  "mypage.orderProposal.delete": "Ta bort",
  "mypage.orderProposal.validUntil": "Orderförslaget gäller t.o.m.",
  "mypage.orderProposal.quantityText": "Visar {current} av {total} orderförslag",
  "mypage.orderProposal.showMoreCta": "Visa fler",
  "mypage.orderProposal.cartLoaded": "Varukorg hämtad – du redigerar nu orderförslag #{id} för kund {name}",
  "mypage.orderProposal.deleted": "Orderförslaget raderades",
  "mypage.orderProposal.moreInfo": "Mer information",
  "mypage.overview": "Översikt",
  "mypage.password.subheadline": "Mitt lösenord",
  "mypage.password.text": "Här kan du redigera ditt lösenord.",
  "mypage.rejectOrderProposal": "Avvisa orderförslag",
  "mypage.rejectOrderProposal.option.brands": "Fel varumärken",
  "mypage.rejectOrderProposal.option.notSpecify": "Vill inte ange",
  "mypage.rejectOrderProposal.option.other": "Annat",
  "mypage.rejectOrderProposal.option.price": "För dyrt",
  "mypage.rejectOrderProposal.option.requirements": "Uppfyller inte våra krav",
  "mypage.rejectOrderProposal.send": "Skicka",
  "mypage.rejectOrderProposal.text": "Välj en orsak till avvisat orderförslag",
  "mypage.rejectOrderProposal.writeHere": "Skriv här",
  "mypage.confirmOrderproposalModalTitle": "Vänligen bekräfta",
  "mypage.confirmOrderproposalModalText": "Du har redan en aktiv varukorg med produkter i. Vill du behålla de produkterna eller ta bort dom?",
  "mypage.sales.confirmOrderproposalModalText": "Du har redan en aktiv varukorg med produkter i. Töm varukorgen för att fortsätta att redigera detta orderförslag.",
  "mypage.sales.customers": "Mina kunder",
  "mypage.sales.dashboard": "Översikt",
  "mypage.sales.favorites": "Favoriter",
  "mypage.sales.headline": "Säljverktyg",
  "mypage.sales.onboarding": "Om säljverktyget",
  "mypage.user.onboarding": "Om mina sidor",
  "mypage.sales.onboarding.close": "Stäng",
  "mypage.sales.onboarding.next": "Nästa",
  "mypage.sales.onboarding.progress": "Steg {activeIndex} av {totalSlides}",
  "mypage.sales.orderHistory": "Ordrar",
  "mypage.sales.orderProposal": "Orderförslag",
  "mypage.settings": "Inställningar",
  "mypage.settings.CustomerNo": "Kundnummer",
  "mypage.settings.address": "Mina leverans- och fakturauppgifter",
  "mypage.settings.address.text": "Här kan du som administratör redigera leverans- och faktureringsuppgifter för salongen",
  "mypage.settings.companyName": "Företag",
  "mypage.settings.orgNo": "Organisationsnummer",
  "mypage.settings.personal": "Mitt konto",
  "mypage.settings.personal.text": "Här kan du redigera dina personliga kontaktuppgifter.",
  "mypage.settings.subheadline": "Dina uppgifter",
  "mypage.settings.text": "Här kan du redigera dina uppgifter.",
  "mypage.tableHeader.created": "Skapad",
  "mypage.tableHeader.customerNr": "Kundnummer",
  "mypage.tableHeader.salon": "Salong",
  "mypage.tableHeader.status": "Status",
  "mypage.tableHeader.sum": "Totalsumma",
  "mypage.tableHeader.valid": "Giltighetstid",
  "mypage.tableHeader.basketId": "Order ID",
  "mypage.users.add": "Lägg till användare",
  "mypage.users.add.submit": "Bjud in",
  "mypage.users.add.success": "Användare med epost {email} har nu blivit inbjuden!",
  "mypage.users.delete": "Radera användare",
  "mypage.users.delete.confirm": "Är du säker på att du vill radera användaren? Åtgärden kan inte ångras.",
  "mypage.users.edit": "Redigera användare",
  "mypage.users.role.admin": "Administratör",
  "mypage.users.role.admin.about": "En admin har möjlighet att ändra vissa kontoinställningar, lägga beställningar och bjuda in nya användare till salongen.",
  "mypage.users.role.edit": "Behörighet",
  "mypage.users.role.finance": "Ekonomiansvarig",
  "mypage.users.role.finance.about": "Begränsad åtkomst. Kan bara hantera fakturor.",
  "mypage.users.role.user": "Användare",
  "mypage.users.role.user.about": "En användare kan bara lägga beställningar till salongen och inte ändra kontoinställningar.",
  "mypage.users.subheadline": "Användarkonton",
  "mypage.users.text": "Här kan du som administratör lägga till användare till salongen",
  "mypage.customersuccess.notimpersonating": "Vänligen välj att logga in som en kund genom att klicka på 'Logga in som kund' i toppen för att se mer information på mina sidor.",
  "newsletter.success": "Du har nu anmält dig till vårat nyhetsbrev",
  "notify.modal.button": "Starta bevakning",
  "notify.modal.text": "Ange din epost för att bevaka produkt",
  "notify.modal.title": "Bevaka produkt",
  "notify.openModalButton": "Bevaka",
  "order.articleNoPrefix": "Art. nr:",
  "order.history.active": "Aktiva",
  "order.history.all": "Alla ordrar",
  "order.history.cancel": "Avbrutna",
  "order.history.onhold": "Parkerade",
  "order.history.delivered": "Levererade",
  "order.item.count": "{count} st",
  "order.quantityPrefix": "Antal:",
  "order.quantityText": "Visar {current} av {total} ordrar",
  "order.repurchaseCta": "Handla igen",
  "order.showMoreCta": "Visa mer",
  "order.sizePrefix": "Storlek:",
  "order.status.allocation": "Mottagen - ordern är mottagen av Session Map",
  "order.status.allocation.short": "Mottagen",
  "order.status.backorder": "Restorder - inväntar leverans från leverantör",
  "order.status.backorder.short": "Restorder",
  "order.status.cancelled": "Annullerad",
  "order.status.cancelled.short": "Annullerad",
  "order.status.confirmed": "Bekräftad - klar för att plockas",
  "order.status.confirmed.short": "Bekräftad",
  "order.status.onhold": "Parkerad",
  "order.status.onhold.short": "Parkerad",
  "order.status.created": "Skapad",
  "order.status.created.short": "Skapad",
  "order.status.customerSuccess": "Order lagd av: Kundtjänst",
  "order.status.delivered": "Levererades den {date}",
  "order.status.delivered.short": "Levererad",
  "order.status.deliveredNoDate": "Levererad",
  "order.status.deliveredNoDate.short": "Levererad",
  "order.status.invoiced": "Fakturerad",
  "order.status.partDelivered": "Delvis levererad - följ din order här",
  "order.status.partDelivered.short": "Dellevererad",
  "order.status.partDelivered.link": "Delvis levererad - <span class='underline cursor-pointer'>följ din order här</span>",
  "order.status.processing": "Behandlas - Förbereder leverans",
  "order.status.processing.short": "Behandlas",
  "order.status.reserved": "Order plockas - vi plockar och packar din order",
  "order.status.reserved.short": "Order plockas",
  "order.status.sales": "Order lagd av: Säljare",
  "order.status.sending": "På väg - Beräknad leverans: {date}",
  "order.status.sending.short": "På väg",
  "order.status.sendingNoDeliveryDate": "På väg",
  "order.status.sendingNoDeliveryDate.short": "På väg",
  "order.status.shipped": "Skickad - order påväg, följ din order här",
  "order.status.shipped.short": "Skickad",
  "order.status.shipped.link": "Skickad - order påväg, <span class='underline cursor-pointer'>följ din order här</span>",
  "order.status.track": "Spåra order",
  "order.title": "Orderhistorik",
  "order.title.mobile": "Ordrar",
  "orders.orderDate": "Beställningsdatum",
  "orders.orderNo": "Ordernummer",
  "orders.pending": "Det kan ta upp till 15 minuter innan lagda ordrar visas i listan",
  "orders.table.orderdate": "Beställningsdatum",
  "orders.table.ordernumber": "Ordernummer",
  "orders.table.priceSum": "Totalsumma ex moms",
  "orders.table.quanity": "Antal",
  "orders.table.status": "Status",
  "order.outOfStockModal.title": "Det gick inte att lägga alla varor i varukorgen",
  "order.outOfStockModal.text": "Följande varor finns antingen inte i lager eller inaktiva: {products}.",
  "order.outOfStockModal.hasActiveProductsText": "Vill du lägga resten som finns i lager i varukorgen?",
  "order.outOfStockModal.hasNoActiveProductsText": "Inga av varorna i den här ordern finns i lager eller är aktiva",
  "order.outOfStockModal.confirm": "Ja, lägg i varukorgen",
  "order.outOfStockModal.cancel": "Avbryt",
  "pointshop.checkout.tooltip": "Efter genomfört köp kan du handla backbars och testers för poängen",
  "pointshop.head.closingIn": "Ordern stängs om",
  "pointshop.head.continue": "Granska",
  "pointshop.head.noSelected": "Inga produkter valda",
  "pointshop.head.points": "{cur} av {max}",
  "pointshop.head.selectedPlur": "{num} produkter vald",
  "pointshop.head.selectedSingl": "1 produkt vald",
  "pointshop.head.toShopFor": "Poäng att handla för:",
  "pointshop.head.undo": "Rensa",
  "pointshop.product.isPoints": "Poängvara",
  "pointshop.product.showPoints": "{num} poäng",
  "pointshop.notEnough": "Du har inte tillräckligt med poäng",
  "pointshop.reminder": "Du har poäng att handla för.",
  "pointshop.reminder.click": "Klicka här",
  "price.exVat.short": "exkl. moms",
  "price.incVat.short": "inkl. moms",
  "price.notLoggedIn": "Logga in för att se pris",
  "priceInfo.discountLabel": "Rabatt",
  "priceInfo.loginForPriceInfo": "Logga in för att se pris",
  "priceInfo.financeUserTooltip": "Din roll medger ej att handla på session.nu, kontakta kundservice",
  "priceInfo.shippingLabel": "Frakt",
  "priceInfo.totalPriceBeforeVat": "Delsumma exkl. moms",
  "priceInfo.totalPriceLabel": "Delsumma inkl. moms",
  "productList.autoNav.all": "Alla",
  "productList.empty.headline": "Här fanns inga produkter",
  "productList.empty.text": "Eventuellt har du inte tillgång till produkterna på denna sida. Kontakta oss om du är intresserad av att köpa detta sortiment",
  "productList.flags.colorMap": "Färgkarta",
  "productList.hide.content": "Göm content",
  "productList.priceHistory.lowest": "Lägsta pris {price}",
  "productList.product.hasVariants": "Finns i fler varianter",
  "productList.search.placeholder": "Sök produkt...",
  "productPage.bundles.btnText": "Köp paketet",
  "productPage.bundles.contains": "Paketet innehåller",
  "productPage.bundles.readAboutBundle": "Läs mer om paketet",
  "productPage.bundles.title": "Finns även i paket!",
  "productPage.extended.shade": "1 nyans",
  "productPage.extended.shades": "{num} nyanser",
  "productPage.extended.notLoggedIn": "Se pris",
  "productPage.faqModal.title": "FAQ",
  "productPage.favorites.text": "Du har inga favoriter. Klicka på hjärtat vid produkten om du vill spara den som din favorit.",
  "productPage.favorites.title": "Favoriter",
  "productPage.fitDisplay.large": "Stor",
  "productPage.fitDisplay.normal": "Perfekt",
  "productPage.fitDisplay.small": "Liten",
  "productPage.fitDisplay.title": "Upplevd storlek",
  "productPage.hairtv.description": "Vi gir deg opplæringsfilmer laget av verdenskjente stylister og noen av Norges beste frisører. Lær av bl.a Lotte Myrseth og Guy Tang - akkurat når det passer deg!",
  "productPage.hairtv.link": "Se fler videos på HairTV.no",
  "productPage.hairtv.title": "Om HairTv",
  "productPage.info.about": "Om produkten",
  "productPage.info.crossell": "Köps ofta tillsammans",
  "productPage.info.downloadDocs": "Ladda ner material",
  "productPage.info.guidesAndInspiration": "Guider och inspiration",
  "productPage.info.hairTvVideos": "Videos från HairTV",
  "productPage.info.ingredients": "Ingredienser",
  "productPage.lastVisited.title": "Senast visade",
  "productPage.partNo": "Artikelnummer",
  "productPage.partNo.short": "Art.nr",
  "productPage.price.original": "Ord. pris",
  "productPage.price.yourDiscount": "din rabatt",
  "productPage.priceHistory.date": "Datum",
  "productPage.priceHistory.price": "Pris",
  "productPage.priceHistoryModal.title": "Prishistorik",
  "productPage.promotions.youSave": "Du sparar",
  "productPage.relatedProducts.addOns": "Tillbehör",
  "productPage.relatedProducts.colorhydrogen": "Väte",
  "productPage.relatedProducts.colorbleach": "Blekning",
  "productPage.relatedProducts.colormaterial": "Material",
  "productPage.relatedProducts.fromBrand": "Upptäck mer från {brand}",
  "productPage.relatedProducts.relatedproducts": "Relaterade produkter",
  "productPage.relatedProducts.upsel": "Andra köpte också",
  "productPage.search.placeholder": "Sök namn, level eller artikelnummer",
  "productPage.similarProducts.title": "Liknande produkter",
  "productPage.sizeSelector.addToCartBtn": "Lägg i varukorgen",
  "productPage.sizeSelector.preOrder": "Förhandsboka",
  "productPage.sizeSelector.comingSoon": "Kommer snart",
  "productPage.sizeSelector.quantityLabel": "Antal",
  "productPage.sizeSelector.sizeGuideTitle": "Storleksguide",
  "productPage.sizeSelector.watchStockBtn": "Bevaka",
  "productPage.stockAlertError": "Det gick inte att bevaka produkten för tillfället. Försök igen senare!",
  "productPage.stockAlertPlaceholder": "Fyll i epost för att bevaka",
  "productPage.stockAlertSuccess": "Du bevakar nu den här produkten!",
  "productPage.stockAlertSuccessAgain": "Du bevakar redan den här produkten!",
  "productPage.truncateTextCtaClosed": "Läs mer",
  "productPage.truncateTextCtaOpen": "Läs mindre",
  "quickbuy.button": "Lägg i varukorg",
  "search.brandSuggestion": "Varumärke",
  "search.cancel": "Stäng",
  "search.nohits": "Din sökning gav inget resultat",
  "search.page.headline": "Visar resultat för {search}",
  "search.page.hits.plur": "{num} träffar",
  "search.page.hits.sing": "1 träff",
  "search.page.others": "Övriga sidor",
  "search.page.othersHeadline": "Övriga sidor",
  "search.page.othersMissingHeadline": "Inga artiklar",
  "search.page.othersMissingText": "Tyävrr, inga artiklar finns här",
  "search.page.products": "Produkter",
  "search.pagetype.BrandPage": "Varumärke",
  "search.pagetype.page": "Sida",
  "search.placeholder": "Sök produkter, kategorier, varumärken…",
  "search.popularProducts": "Populära produkter just nu",
  "search.showAll": "Visa alla sökträffar",
  "search.suggestions": "Sökförslag",
  "signin.emailPlaceholder": "E-postadress",
  "signin.forgot.button": "ÅTERSTÄLL LÖSENORD",
  "signin.forgot.confirmPasswordPlaceholder": "Bekräfta lösenord",
  "signin.forgot.confirmationText": "Om din e-post finns registrerad har vi nu skickat ett återställningsmail.",
  "signin.forgot.headline": "Välj ett nytt lösenord",
  "signin.forgot.setNew": "Spara nytt lösenord",
  "signin.forgot.success": "Ditt lösenord är nu uppdaterat. Du loggas automatiskt in inom kort.",
  "signin.forgot.text": "Ange din registrerade e-postadress för att återställa ditt lösenord.",
  "signin.forgot.title": "Återställ lösenord",
  "signin.forgotPassword": "Glömt ditt lösenord?",
  "signin.invoiceemailPlaceholder": "E-post för faktura",
  "signin.modalTitle": "Logga in",
  "signin.passwordPlaceholder": "Lösenord",
  "signin.signin": "Logga in",
  "signin.welcome.headline": "Slutför registreringen",
  "signin.welcome.justRegistered": "Välkommen till Session Map",
  "signin.welcome.justRegisteredText": "Ditt konto på Session Map har nu skapats och ett bekräftelsemail har skickats till din e-post. Klicka på länken i mailet för att ange ditt lösenord och logga in.",
  "signin.welcome.setNew": "Skapa konto och logga in",
  "signin.welcome.text": "Bestäm ett säkert lösenord till ditt konto för att slutföra registreringen och logga in!",
  "signup.complete": "Ditt konto skapades",
  "signup.complete.headline": "Hej, {name}!",
  "signup.complete.text": "Välkommen till Session Map.",
  "signup.complete.toMyPage": "Gå till mina sidor",
  "signup.complete.toShopping": "Börja shoppa",
  "signup.cta": "Registrera dig",
  "signup.error.passwordNoMatch": "Lösenorden matchar inte",
  "signup.error.passwordNoStrength": "Lösenordet måste vara 8 bokstäver",
  "signup.noAccount": "Inte kund än?",
  "signup.placeholder.careof": "c/o",
  "signup.placeholder.city": "Ort",
  "signup.placeholder.companyName": "Företagsnamn",
  "signup.placeholder.country": "Land",
  "signup.placeholder.email": "E-post",
  "signup.placeholder.firstName": "Förnamn",
  "signup.placeholder.lastName": "Efternamn",
  "signup.placeholder.newPass1": "Nytt lösenord",
  "signup.placeholder.newPass2": "Bekräfta nytt lösenord",
  "signup.placeholder.oldPass": "Nuvarande lösenord",
  "signup.placeholder.orgNo": "Organisationsnummer",
  "signup.placeholder.phone": "Telefonnummer",
  "signup.placeholder.street": "Adress",
  "signup.placeholder.street2": "Adress 2",
  "signup.placeholder.zip": "Postnummer",
  "signup.usp1": "Tillgång till exklusiva erbjudanden och kampanjer",
  "signup.usp2": "Snabbare och enklare betalningsprocess",
  "signup.usp3": "Notiser när dina favoriter är tillbaka i lager eller på rea",
  "siteName": "Session Map",
  "siteNotice.loggedInAs": "Inloggad som {name} ({id})",
  "siteNotice.changeSalon": "Byt salong",
  "siteNotice.changeSalon.customerSuccess": "Byt kund",
  "siteNotice.pointshopEnabled": "Kund har tillgång till poängshopen",
  "siteNotice.editingOrderProposal": "Redigerar orderförslag",
  "siteNotice.editingOrderProposalCustomer": "Den här varukorgen är skapad från ett orderförslag",
  "stock.backInStock": "Beräknat åter i lager {date}",
  "stock.cantAddMoreToCart": "Du kan inte lägga fler av den här varan i varukorgen då vi inte har tillräckligt i lager.",
  "stock.maxCanAdd": "Det går inte att lägga till fler än {num}",
  "stock.maxInCart": "Det går inte att lägga till fler än de du redan har i din varukorg",
  "stock.inStock": "Finns i lager",
  "stock.inStockSendWithinDays": "Finns i lager, hos dig inom 2-3 vardagar",
  "stock.sendWithin23Days": ", hos dig inom 2-3 vardagar",
  "stock.isOnDemandProduct": "Beställningsvara, skickas om {num} dagar",
  "stock.isOnDemandProductWithLineBreak": "Beställningsvara <br>skickas om {num} dagar",
  "stock.lowstock": "Vi har enbart {num} i lager",
  "stock.productHasExpired": "Produkten har utgått ur sortimentet",
  "stock.discontinued": "Utgått",
  "stock.productIsDiscontinued": "Produkten har utgått",
  "stock.releaseDate": "Releasedatum {date}",
  "stock.releaseDateWithLineBreak": "Releasedatum <br>{date}",
  "stock.sendWithinDays": "Skickas inom {num} dagar",
  "stock.soldout": "Slut i lager",
  "stock.soldoutShort": "Slutsåld",
  "stock.tempDisabled": "Produken kan tyvärr inte köpas för tillfället",
  "stock.tempSoldout": "Tillfälligt slut i lager, beräknad åter {date}",
  "stock.tempSoldoutWeek": "Tillfälligt slut i lager, återkommer v. {week}",
  "stock.tempSoldoutWeekShort": "Tillfälligt slut, åter v. {week}",
  "stock.tempSoldoutShort": "Tillfälligt slut",
  "stock.notInStock": "Ej i lager",
  "stock.expired": "Utgått",
  "lockedPage.headline": "Logga in eller registrera dig för att få access till denna sida",
  "lockedPage.text": "Registrera dig och utforska inte bara det senaste inom produkter utan även våra expertguider. För frisörer som vill vara ett klipp före!",
  "events.loadMore": "Visar {current} av {total} events",
  "buyMore.inCheckout": "Rabatten appliceras i varukorgen.",
  "buyMore.saveAtleast.from": "Du sparar fr. {sum}",
  "buyMore.saveAtleast.exact": "Du sparar {sum}",
  "buyMore.perItem": "{sum}/st",
  "buyMore.steps": "Köp {buy} - få {get} extra gratis",
  "buyMore.nextCta.amount": "Lägg till {num} st",
  "buyMore.nextCta.percent": " - få {percent}% rabatt",
  "buyMore.plp.flag": "Köp fler, spara mer!",
  "buyMore.plp.gift-flag": "Gåva på köpet",
  "buyMore.multiCampaign-selectionHeadline": "Välj kampanj",
  "buyMore.multiCampaign-headline": "Köp fler, spara mer",
  "buyMore.multiCampaign-description": "Kampanjen tillämpas automatiskt i kassan",
  "buyMore.unique-headline": "Köp till ditt unika pris",
  "buyMore.gift-headline": "Gåva på köpet",
  "checkout.amount.more": "Fler",
  "checkout.gift": "Gåva",
  "productPage.extended.showAll": "Visa allt",
  "minicart.discount.invalidDiscount": "Ogiltig rabatt",
  "modal.generic.abort": "Avbryt",
  "modal.generic.deleteText": "Är du säker på att du vill radera?",
  "modal.generic.delete": "Radera",
  "modal.generic.ok": "Ok",
  "modal.generic.save": "Spara",
  "invoices.ledger.request": "Begär reskontra",
  "invoices.ledger.requested": "Reskontra begärd",
  "invoices.ledger.success": "Reskontra begärd, du kommer få ett mail med dina uppgifter inom ca tre arbetsdagar",
  "productPage.extended.variantNews": "Nyhet",
  "mypage.fastOrder": "Skapa snabborder",
  "mypage.sales.fastOrder": "Power Order",
  "fastorder.table.partNo": "Art.no.",
  "fastorder.table.brand": "Varumärke",
  "fastorder.table.name": "Produkt",
  "fastorder.table.num": "Antal",
  "fastorder.table.discount": "Rabatt %",
  "fastorder.table.priceStandard": "Pris std",
  "fastorder.table.priceUser": "Pris kund",
  "fastorder.table.margin": "Marginal %",
  "fastorder.table.total": "Totalsumma",
  "fastorder.upload": "Ladda upp CSV",
  "fastorder.upload.file": "Ladda upp fil",
  "fastorder.upload.text": "eller klistra in text:",
  "fastorder.upload.error": "Kunde inte läsa CSV. Kontrollera filen och försök igen",
  "fastorder.error.noFile": "Ingen fil vald",
  "fastorder.error.notTextFile": "Filen var inte en text fil",
  "fastorder.error.unknown": "Ett okänt fel inträffade. Kontrollera filen och försök igen",
  "fastorder.create": "Power Order",
  "fastorder.noCustomer": "Ingen kund vald",
  "fastorder.makePurchase": "Köp med faktura",
  "fastorder.searchPlaceholder": "Lägg till produkt genom att söka på artikelnummer eller namn…",
  "fastorder.changeSalon": "Byt salong",
  "fastorder.changeSalon.warning": "Varning!, byta salong raderar ordern.",
  "fastorder.changeSalon.cancel": "Avbryt",
  "fastorder.default": "Hantera order",
  "fastorder.clear": "Töm order",
  "fastorder.update": "Uppdatera",
  "fastorder.template.load": "Ladda mall",
  "fastorder.template.loadShort": "Ladda",
  "fastorder.template.delete": "Radera",
  "fastorder.template.save": "Spara mall",
  "fastorder.template.name": "Välj namn",
  "fastorder.template.replace": "Det finns redan en mall med det namnet. Den kommer skrivas över",
  "fastorder.showPreview": "Förhandsgranska",
  "fastorder.hidePreview": "Stäng förhandsvisning",
  "fastorder.preview.headline": "Förhandsgranska order",
  "fastorder.notGift": "Inte tillgänglig som gåva",
  "fastorder.duplicateLine": "Duplicera rad",
  "fastorder.summary": "Summering:",
  "fastorder.gift": "Gåva",
  "fastorder.duplicateWarning.text": "Du har redan lagt till den här produkten i listan, vill du lägga till en till?",
  "fastorder.duplicateWarning.abort": "Avbryt",
  "fastorder.duplicateWarning.add":  "Lägg till",
  "fastorder.templateMerge.text": "Vill du kombinera mallen med produkterna du redan lagt in i listan?",
  "fastorder.templateMerge.abort":"Nej, ersätt listan med min mall",
  "fastorder.templateMerge.add": "Ja, kombinera mallen och listan",
  "barcode.add": "Lägg till",
  "barcode.scan": "Skanna",
  "barcode.notFound": "Inget resultat: ",
  "barcode.popup.text": "Det finns funna produkter du inte än lagt till i listan, är du säker på att du vill stänga?",
  "barcode.popup.close": "Jag är säker, stäng ner",
  "barcode.popup.continue": "Jag vill fortsätta",
  "loadCart.placeholder": "Ladda en cart med id nummer",
  "loadCart.submit": "Ladda",
  "loadCart.validation": "Id innehåller bara siffror",
  "mypage.orderProposal.mergeBaskets": "Behåll varukorg",
  "mypage.orderProposal.emptyBasket": "Töm varukorg",
  "stock.std.over100": "Över 100 på lager, hos dig inom 2-3 vardagar",
  "stock.std.over50": "Över 50 på lager, hos dig inom 2-3 vardagar",
  "stock.std.over25": "Över 25 på lager, hos dig inom 2-3 vardagar",
  "stock.std.less25": "Färre än 25 på lager, hos dig inom 2-3 vardagar",
  "stock.alt.over5": "Över 5 på lager, hos dig inom 2-3 vardagar",
  "stock.alt.less5": "Färre än 5 på lager, hos dig inom 2-3 vardagar",
  "product.recommendedPrice.short": "Rek. pris",
  "productPage.bundles.showAll": "Visa hela innehållet ({num})",
  "productPage.bundles.showLess": "Dölj",
  "flag.new": "Nyhet",
  "flag.sale": "Rea",
  "checkout.order.company": "Ordern läggs för företag {company}",
  "checkout.additionalInformation": "Extra information",
  "checkout.additionalInformation.comment": "Kommentar",
  "checkout.additionalInformation.invoiceNotice": "Fakturamärkning",
  "order.invoiceNotice.label": "Fakturamärkning",
  "fastorder.table.hiddenProduct": "Detta är en produkt som inte visas ute på sidan",
  "fastorder.max_quantity_reached": "Max antal tillagt i varukorgen",
  "checkout.addDiscountModal.description": "Välj hur många {name} du vill lägga till i ordern och hur mycket rabatt det ska vara på produkten.",
  "fastorder.fromPromotion": "{num} st från kampanj",
  "fastorder.freeFromPromotion": "Gratis från kampanj",
  "fastorder.fromPromotion.headline": "Gåvor",
  "mypage.declineOrderProposal.success": "Orderförslaget avvisades",
  "fastOrder.row.user_pricelist": "Användarens prislista",
  "fastOrder.row.std_pricelist": "Standard prislista",
  "fastOrder.row.promotion_available": "promotion tillgänglig",
  "fastOrder.row.no_promotion_available": "ej promotion",
  "order.cancel": "Makulera order",
  "order.cancel.warning": "Är du säker på att du vill makulera denna order?",
  "order.cancel.confirm": "Ja, makulera",
  "order.cancel.successMessage": "Ordern makulerades",
  "order.edit.warning": "Är du säker på att du vill redigera denna order?",
  "order.edit.confirm": "Ja, redigera",
  "order.edit.successMessage": "Ordern är tillagd i varukorgen och kan redigeras.",
  "mypage.communications.backorderStockAlerts": "Ja, skicka backorder status alerts",
  "minicart.crossdocking.title": "OBS! Din varukorg innehåller en eller flera produkter som för tillfället är slut i lager.",
  "minicart.crossdocking.contentFirst": "Du kan fortfarande genomföra köpet men produkten/produkterna kommer skickas med din nästa beställning.",
  "minicart.crossdocking.contentSecond": "Du kan även kryssa i checkboxen för att få produkten skickade när det åter är i lager för en extra fraktkostnad på 69 kr per produkt.",
  "stock.sendWhenInStock": "Skicka så fort den är i lager",
  "crossDocking.shipping": "Extraleverans",
  "account.emptyBackorder.title": "Inga backorders",
  "account.emptyBackorder.subTitle": "Inga backorders description",
  "mypage.backorders": "Backorders",
  "mypage.backorders.mobile": "Backorders mobile",
  "mypage.backorders.product": "Produkt",
  "mypage.backorders.deliveryDate": "Datum för utleverans",
  "mypage.backorders.description": "backorders desc",
  "checkout.backorder.sendWhenInStock": "Denna vara skickas i en separat försändelse så fort den inkommer i lager",
  "product.backorderNotice": "OBS! Du har redan lagt en beställning av {quantity} st som ännu inte levererats till dig.",
  "product.backorderNoticeWithDate": "OBS! Du har redan lagt en beställning av {quantity} st som ännu inte levererats till dig. Redo att skickas {date}",
  "productPage.buybox.confirmBackorderTitle": "OBS! Produkten är tillfälligt slut i lager och är beräknad åter {date}.",
  "productPage.buybox.confirmBackorderContentFirst": "Du kan fortfarande genomföra köpet men produkten kommer skickas med din nästa beställning.",
  "productPage.buybox.confirmBackorderContentSecond": "I varukorgen kan du kryssa i en checkbox för att få produkten skickade när det åter är i lager för en extra fraktkostnad på 69 kr",
  "fastorder.noRows": "Inga tillagda produkter",
  "fastOrder.noTemplates" : "Du har inga sparade mallar",
  "siteNotice.editingOrder": "Redigerar order",
  "order.replacingOrder": "Ersätter order #{orderId}",
  "company.suspended": "Ditt konto är spärrat. Kontakta kundtjänst.",
  "company.suspended.siteNotice": "Företaget är spärrat.",
  "company.suspended.short": "Spärrat",
  "cart.clear": "Rensa varukorgen",
  "minicart.carts.createSuccess": "Varukorgen rensades!",
  "fastOrder.globalDiscount": "Global rabatt",
  "order.updateStatus.warning": "Är du säker på att du vill uppdatera status till Öppen på denna order?",
  "order.updateStatus.confirm": "Ja, uppdatera status",
  "order.updateStatus.btn": "Uppdatera status till Öppen",
  "order.updateStatus.successMessage": "Orderns status uppdaterades",
  "mypage.carts": "Varukorgar",
  "mypage.carts.filter.year": "År",
  "mypage.carts.created": "Skapad",
  "account.emptyCarts.title.selection": "Du inga sparade varukorgar för det valda året/urvalet",
  "account.emptyCarts.subTitle.selection": "Välj ett annat år eller urval för att se sparade varukorgar.",
  "mypage.carts.quantityText": "Visar {current} av {total} varukorgar",
  "mypage.carts.addedToCart": "Varukorgen uppdaterades",
  "mypage.carts.current": "Nuvarande",
  "mypage.customer.showCompanyInfo": "Se kundinformation",
  "mypage.carts.create": "Skapa ny varukorg",
  "minicart.carts.create": "Skapa ny varukorg",
  "minicart.carts.createNewSuccess": "En ny varukorg har skapats!",
  "mypage.carts.created_by": "Skapad av",
  "minicart.savedCart.messsage": "Varukorg #{cartId} skapad {date} av {name} är satt som aktiv",
  "mypage.preview.addToCart": "Ladda varukorg",
  "mypage.preview.addToCartImpersonate": "Logga in som kund och ladda varukorg",
  "minicart.carts.delete": "Ta bort",
  "minicart.carts.deleteSuccessMsg": "Varukorgen har tagits bort",
  "mypage.customer.companyInfo": "Kundinformation",
  "mypage.company.note": "Anteckning",
  "mypage.company.saveNote": "Spara anteckning",
  "mypage.dashboard": "Försäljningsöversikt",
  "mypage.dashboard.desc": "Realtidsöversikt över ordrar, lager och försäljning",
  "mypage.dashboard.inventory": "Lager",
  "mypage.dashboard.createOrder": "Skapa order",
  "mypage.dashboard.todayOrderSum": "Dagens ordervolym",
  "mypage.dashboard.todayOrders": "Dagens ordrar",
  "mypage.dashboard.parkedOrders": "Parkerade ordrar",
  "mypage.dashboard.parkedOrders.needsAction": "Behöver åtgärdas",
  "mypage.dashboard.parkedOrders.needsActionShort": "Åtgärda",
  "mypage.dashboard.latestOrders": "Senaste ordrar",
  "mypage.dashboard.latestOrders.show": "Visa",
  "mypage.dashboard.soldOutProducts": "Slut i lager",
  "mypage.dashboard.incomingInventory": "Inkommande lager",
  "mypage.dashboard.bestSellersToday": "Toppsäljare idag",
  "mypage.dashboard.showAll": "Se alla",
  "mypage.dashboard.orderDiffMessage": "{prefix}{count} {suffix} från igår",
  "mypage.inventory": "Lager",
  "mypage.inventory.new": "Kommande produkter",
  "mypage.dashboard.noProducts": "Inga produkter",
  "mypage.dashboard.noOrders": "Inga ordrar",
  "mypage.dashboard.orderVolume.week": "Ordervolym senaste 7 dagarna",
  "mypage.dashboard.orderVolume.month": "Ordervolym senaste 30 dagarna",
  "mypage.dashboard.orderVolume.weekBtn": "7 dagar",
  "mypage.dashboard.orderVolume.monthBtn": "30 dagar",
  "mypage.dashboard.expiredInvoices": "Förfallna fakturor",
  "mypage.dashboard.noInvoices": "Inga förfallna fakturor",
  "mypage.dashboard.sendReminder": "Skicka påminnelse",
  "mypage.dashboard.reminderSent": "Påminnelsen skickades!",
  "product.splash.limitedEdition": "Limited Edition",
  "product.splash.comingSoon": "Kommande",
  "checkout.grossProfit.title": "Ditt täckningsbidrag",
  "checkout.grossProfit.1": "Ajdå, marginalen behöver en livräddning… vem är vinnaren?",
  "checkout.grossProfit.2": "Hua, bra deal för salongen… är dem värda den, vad får vi för ROI på investeringen?",
  "checkout.grossProfit.3": "Fortfarande fördel salongen, de har en bättre deal än Dig och Session, sikta på win-win.",
  "checkout.grossProfit.4": "Bra, vi har en sund affär! Lite till på marginalen och vi har en fin balans i vår affär.",
  "checkout.grossProfit.5": "Underbart, snyggt jobbat och vi har en bra affär… skicka ordern!",
  "checkout.grossProfit.6": "Du är en stjärna! Fortsätt i bra fart mot stjärnorna… klicka igenom ordern!",
  "price.from": "Från",
  "mypage.dashboard.showingInvoices": "Visar {current} av {total} fakturor"
}
